import React from 'react'
import { useNavigate } from 'react-router-dom'
import iconlogo2 from '../assets/iconLogo2.png'
import google from '../assets/gapp_scaled.png'
import apple from '../assets/iapp_scaled.png'
import { FaFacebook, FaInstagram, FaXTwitter} from "react-icons/fa6";

const Footer = () => {
  const send = useNavigate();

  const route = (url) => {
    upTo();
    send(url);
  }


  const upTo = () => {
    window.scrollTo({
     top: 0,
     left: 0,
     behavior: 'smooth'      
    });
  }


  return (
    <>
      <footer class="bg-[#060d1a] border-t border-[#e7f1f3] dark:border-[#1e3438] py-12">
        <div class="max-w-[1200px] mx-auto px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div class="flex flex-col gap-4">
        <div class="flex items-center gap-2 text-[#0d191c] dark:text-primary">
        <div class="size-12" onClick={(e) => route("/")}>
          <img src={iconlogo2}/>
        </div>
        <h2 class="text-xl font-bold ml-2 text-white" onClick={(e) => route("/")}>Beeppee</h2>
        </div>
        <p class="text-sm text-[#4b8e9b] dark:text-gray-400">The most versatile tracking platform. Built for families, fleets, and adventurers.</p>
        </div>
        <div>
        <h4 class="font-bold mb-4 text-white">Quick Links</h4>
        <ul class="flex flex-col gap-2 text-sm text-[#4b8e9b] dark:text-gray-400">
        <li><a class="hover:text-primary" onClick={(e) => route("/shop/0")} >Products</a></li>
        <li><a class="hover:text-primary" >FAQ</a></li>
        <li><a class="hover:text-primary" >Refund policy</a></li>
         <li><a class="hover:text-primary" onClick={(e) => route("/consent")}>Tracking &amp; Consent Policy</a></li>
        </ul>
        </div>
        <div>
        <h4 class="font-bold mb-4 text-white">Support</h4>
        <ul class="flex flex-col gap-2 text-sm text-[#4b8e9b] dark:text-gray-400">
        <li><a class="hover:text-primary" onClick={(e) => route("/contact")}>Help Center</a></li>
        <li><a class="hover:text-primary">Device Pairing</a></li>
        {/* <li><a class="hover:text-primary">Subscription</a></li> */}
        <li><a class="hover:text-primary" onClick={(e) => route("/contact")}>Contact Us</a></li>
        </ul>
        </div>
        <div>
        <h4 class="font-bold mb-4 text-white">Follow Us</h4>

        <div class="flex gap-4">
         <div class="size-10 rounded-full bg-gray-800 flex items-center justify-center  hover:bg-primary/20 hover:text-primary transition-all cursor-pointer">
          <span class="material-symbols-outlined" style={{ color: 'white' }}>groups_2</span>
          </div>
          <div class="size-10 rounded-full bg-gray-800 flex items-center justify-center  hover:bg-primary/20 hover:text-primary transition-all cursor-pointer">
            <a href="https://www.facebook.com/BeeppeeApp" aria-label="Facebook"  style={{ color: 'white' }}><FaFacebook /></a>
          </div>
          <div class="size-10 rounded-full bg-gray-800 flex items-center justify-center  hover:bg-primary/20 hover:text-primary transition-all cursor-pointer">
           <a href="https://www.instagram.com/beeppeeapp" aria-label="Instagram" style={{ color: 'white' }}><FaInstagram /></a>
           </div>
           <div class="size-10 rounded-full bg-gray-800 flex items-center justify-center  hover:bg-primary/20 hover:text-primary transition-all cursor-pointer">
            <a href="https://x.com/BeeppeeApp" aria-label="X (Twitter)" style={{ color: 'white' }}><FaXTwitter /></a>
          </div>
        </div>
          <div class="flex flex-col lg:flex-row gap-2 mt-10 ">
             <a 
                href="https://beeppeeappmode.web.app/" 
                target="_blank" 
                rel="noopener noreferrer">
                <img src={google} className='self-start lg:self-center object-contain w-28 lg:w-24 border-cyan-50 border-2 rounded-md' />
             </a>
              <a 
                href="https://beeppeeappmode.web.app/" 
                target="_blank" 
                rel="noopener noreferrer">
                <img src={apple} className='self-start lg:self-center object-contain w-28 lg:w-24 border-cyan-50 border-2 rounded-md'/>
            </a>
          </div>
        </div>
        </div>
        <div class="max-w-[1200px] mx-auto px-10 mt-12 pt-8 border-t border-[#e7f1f3] dark:border-[#1e3438] flex justify-between items-center text-xs text-[#4b8e9b] dark:text-gray-500">
        <p>© 2026 Beeppee Services Inc. All rights reserved.</p>
        <div class="flex gap-6">
        <a onClick={(e) => route("/privacy-policy")} class="hover:text-primary">Privacy Policy</a>
        <a onClick={(e) => route("/terms")} class="hover:text-primary">Terms of Service</a>
        </div>
        </div>
        <div className='mb-14'></div>
    </footer>
    </> 
  )
}




export default Footer
